import React, { useMemo } from "react";
import "./JSidebar.scss";
import { CMSPage } from "../models";
import { breakpointsMax } from "../breakpoints";
import {
    useWindowSize,
} from '@react-hook/window-size';
import { JCMSBanner, JCMSBannerProps } from "../JBanner/components";


export type JSidebarProps = {
    page?: CMSPage,
    children?: JSX.Element | JSX.Element[]
};

export const JSidebar: React.FC<JSidebarProps> = ({
    page,
    children
}) => {
    const [width] = useWindowSize()

    const leftSideAlign: JCMSBannerProps['leftSideAlign'] = useMemo(() => {
        if (width >= breakpointsMax.md) {
            return 'left-top'
        }
        return 'center'
    }, [width])
    
    return (
        <div className="sidebarTemplateContainer">
            <div className='sidebar'>
                <JCMSBanner
                    {...page?.banner}
                    leftSideAlign={leftSideAlign}
                />
            </div>
            <div className='content'>
                {children}
            </div>

        </div>
    )
}
